<template>
    <v-app class="background-base" view="hHh lpR fFf">
        <v-main>
            <div class="logo">
                <v-img src="./assets/logo-sensus-sign-in.gif" alt="Sensus" width="200px" height="80px" />
                <h1>{{ $t('auth.title') }}</h1>
            </div>
            <div class="login-container">
                <v-text-field class="q-mb-sm" v-model="customer" :label="$t('auth.customer')" :error="authError != null" outlined dense @keydown.enter="getCustomerRealm()" />
                <span>{{ $t(authError) }}</span>
                <v-btn class="provider-btn" @click="getCustomerRealm()">{{ $t('auth.logIn') }}</v-btn>
                <hr class="q-my-lg" />
                <div v-for="provider in loginProviders" v-bind:key="provider.displayName">
                    <v-btn class="provider-btn" @click="login(provider)">{{provider.displayName}}</v-btn>
                </div>
            </div>
        </v-main>
    </v-app>
</template>

<script setup lang="ts">
import AuthManager, {AuthProvider} from "./AuthManager"
import { ref } from 'vue'
import type { Ref } from 'vue'
import '../../images/logo-sensus-sign-in.gif'

//const authError: string | null = ref(null)
const authError: string = null

type Providers = AuthProvider[];

const props = defineProps<{
    providers: Providers
}>()

const { loginProviders, customer, login, getCustomerRealm } = useLogin()

function useLogin()
{
    const loginProviders:Ref<Providers> = ref(props.providers)
    const customer:Ref<string> = ref('')

    function login(provider: AuthProvider)
    {
        AuthManager.continueLogin(provider, null)
    }

    async function getCustomerRealm()
    {
        // lookupCustomerAuthority will run continueLogin if successful
        try {
            await AuthManager.lookupCustomerAuthority(customer.value)
        } catch (error) {
            this.authError = error
        }
    }

    return {
        loginProviders,
        customer,
        login,
        getCustomerRealm,
    }
}
</script>

<style lang="scss" scoped>
.background-base {
    background: url(./bg-body-signin.gif) repeat-x scroll 0 0 #F0F0F0;
    background-size: auto;
}
.login-container {
    max-width: 500px;
    margin: 0 auto;
    padding: 20px 40px 30px 40px;
    border: 3px solid #000000;
    background: #FFF;
}

.logo {
    text-align: center;
    margin-bottom: 20px;

    h1 {
        color: #FFF;
        font-size: 29px;
        font-weight: bold;
        text-transform: uppercase;
        letter-spacing: 3px;
        line-height: 1.2em;
    }
}

.provider-btn {
    width: 100%;
    margin-bottom: 10px;
}
</style>
